<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Cargar abonos</h1>
    </div>

    <div>
      <b-card
        tag="article"
        no-body
        style="max-width: 640px"
        class="custom-card"
      >
        <b-card-header
          header-tag="section"
          class="custom-card-header d-flex justify-content-between align-items-center"
        >
          <h3>Carga de abonos</h3>

          <ButtonWithTooltip
            text="Descargar plantilla"
            @click="downloadTemplate"
            class="m-0"
            tooltip-variant="download-template"
          >
            <template slot="icon">
              <DownloadTableIcon/>
            </template>
          </ButtonWithTooltip>
        </b-card-header>
        <b-card-body class="custom-card-body p-0">
          <form class="custom-form" @submit.prevent="save" novalidate>
            <div class="form-section">
              <simple-alert
                text="Seleccione los siguientes campos para poder cargar sus archivos."
                type="light-gray"
              >
                <template slot="icon">
                  <WarningAlertIcon class="mr-2 alert-icon" />
                </template>
              </simple-alert>

              <div class="custom-form mt-4">
                <div class="form-group">
                  <label for="paymentMethod" class="label"
                    >Método de pago *</label
                  >

                  <FormSelect
                    id="paymentMethod"
                    v-model="form.paymentMethod"
                    :items="paymentMethods"
                    defaultOption="Elegir método de pago"
                    :showError="
                      $v.form.paymentMethod.$error &&
                      !$v.form.paymentMethod.required
                    "
                  />

                  <FormError
                    v-if="
                      $v.form.paymentMethod.$error &&
                      !$v.form.paymentMethod.required
                    "
                    message="Método de pago es requerido"
                  />
                </div>

                <div class="form-group">
                  <label for="paymentDate" class="label">Fecha de abono *</label>

                  <div class="flex-1">
                    <FormDatepicker
                      label-id="paymentDate"
                      :show-calendar="showPaymentDate"
                      style="border: 0"
                      class="custom-form-control p-0"
                      :max="new Date()"
                      hide-header
                      @show="showPaymentDate = true"
                      @hidden="showPaymentDate = false"
                      v-model="form.paymentDate"
                      :class="{
                      'custom-form-control-error': $v.form.paymentDate.$error,
                    }"
                    />
                    <FormError
                      v-if="
                      $v.form.paymentDate.$error &&
                      !$v.form.paymentDate.required
                    "
                      message="Fecha de abono es requerida"
                    />
                  </div>
                </div>
              </div>

              <section class="file-container mt-4">
                <label for="file">Cargar excel de abonos *</label>
                <FileInput
                  class="w-100 mt-2"
                  id-file="file"
                  :acceptFile="['.xls', '.xlsx']"
                  @onChange="onFileChange"
                />
                <FormError
                  v-if="$v.form.file.$error && !$v.form.file.required"
                  message="Excel de abonos es requerido"
                />
              </section>
              <section class="file-container mt-4">
                <label for="records">Cargar constancias *</label>
                <FileInput
                  class="w-100 mt-2"
                  :multiple="true"
                  id-file="records"
                  :acceptFile="['*']"
                  @onChange="onRecordsChange"
                />

                <FormError
                  v-if="$v.form.records.$error && !$v.form.records.required"
                  message="Constancias son requeridas"
                />
              </section>

              <div class="form-group-buttons text-right">
                <router-link
                  :to="{ name: 'celulares-status-made-batch-list' }"
                  class="button button-light"
                >
                  Cancelar
                </router-link>
                <button class="button button-primary" type="submit">
                  Procesar
                </button>
              </div>
              <div class="form-errors mt-3" v-if="errors.length > 0">
                <b
                  ><span class="error" v-if="errors.length > 0"
                    >Errores: {{ errors.length }}</span
                  ></b
                ><br />
                <span
                  v-for="(e, i) in errors"
                  class="file-error"
                  :key="`${i}-error`"
                  >{{ e }}<br
                /></span>
              </div>
            </div>
          </form>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  FileInput,
  FormDatepicker,
  SimpleAlert,
  WarningAlertIcon,
  FormSelect,
  FormError,
  Util,
  DownloadTableIcon,
  ButtonWithTooltip
} from "wize-admin";

import fileDownload from "js-file-download"

import { required, minLength } from "vuelidate/lib/validators";

import { Constants as LocalConstants } from "@/core/utils";

import { PaymentMadeBatchService } from "@/core/services";

export default {
  components: {
    FormDatepicker,
    SimpleAlert,
    FileInput,
    WarningAlertIcon,
    FormSelect,
    FormError,
    DownloadTableIcon,
    ButtonWithTooltip
  },
  name: "PaymentBatchUpload",
  data() {
    return {
      payrollNumber: null,
      errors: [],
      showPaymentDate: false,
      form: {
        paymentMethod: null,
        paymentDate: null,
        paymentMobileDestination: null,
        records: [],
        file: null
      },
      paymentMethods: [
        LocalConstants.PaymentMethods.YAPE,
        LocalConstants.PaymentMethods.PLIN,
        LocalConstants.PaymentMethods.RECHARGE,
        LocalConstants.PaymentMethods.CHIPS
      ],
    };
  },
  methods: {
    async downloadTemplate() {
      try {
        await this.$store.dispatch("app/loading", true);
        const response = await PaymentMadeBatchService.downloadTemplate();
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async save() {
      const self = this;
      self.$v.$touch();
      if (self.$v.$error) return;

      await this.$store.dispatch("app/loading", true);
      this.errors = [];

      let data = {
        ...this.form,
      };

      Object.keys(data).forEach((key) => {
          if (data[key] === null || typeof data[key] === "undefined") {
            delete data[key];
          }
        });

      data = Util.getFormData(data)

      try {
        const resp = await PaymentMadeBatchService.uploadBatch(data);
        if (resp.payload.messages && resp.payload.messages.length > 0) {
          this.errors = resp.payload.messages;
          return;
        }
        Alert.success("Se está procesando la carga de abonos.");
        this.$router.push({ name: "celulares-status-made-batch-list" });
      } catch (e) {
        this.errors = [];
        if (e.errors && e.errors.message) this.errors.push(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    onFileChange(files) {
      if (Array.isArray(files)) {
        this.form.file = files[0];
      } else {
        this.form.file = files;
      }
    },
    onRecordsChange(files) {
      if (Array.isArray(files)) {
        this.form.records = files;
      } else {
        this.form.records = [files];
      }
    },
  },
  computed: {
    isYapePlin() {
      let paymentMethod = this.form.paymentMethod;
      return (
        paymentMethod == LocalConstants.PaymentMethods.YAPE.key ||
        paymentMethod == LocalConstants.PaymentMethods.PLIN.key
      );
    },
    isRecharge() {
      let paymentMethod = this.form.paymentMethod;
      return paymentMethod == LocalConstants.PaymentMethods.RECHARGE.key;
    },
  },
  validations: {
    form: {
      paymentMethod: { required },
      paymentDate: { required },
      records: { required, minLength: minLength(1) },
      file: { required }
    },
  },
  async created() {},
};
</script>

<style lang="stylus" scoped>
</style>
